import { render, staticRenderFns } from "./ConsentScreen.vue?vue&type=template&id=b337ec9c"
import script from "./ConsentScreen.vue?vue&type=script&lang=js"
export * from "./ConsentScreen.vue?vue&type=script&lang=js"
import style0 from "./ConsentScreen.vue?vue&type=style&index=0&id=b337ec9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports